module.exports = __webpack_public_path__ + "static/img/1.e1b8e95.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/sp/1.png
// module id = Ri2K
// module chunks = 0